<template>
  <BaseListPage
      :name="name"
      :base-query="baseQuery"
      :store-path="storePath"
      :response-path="responsePath"
      :save-key="saveKey"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      title="EC在庫一覧"
      title-class="ecStock-header"
      icon="stock"
      :detail-data="detailData">
    <span slot="headerAction"
        class="action_button">
      <el-dropdown
          v-show="showActionList">
        <el-button size="small">
          アクション
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu
            slot="dropdown"
            class="header-action-menu">
          <ToDownload
              ref="download"
              page-key="stock_list"
              :conditions="conditions"
              :keyword="searchKeyword"
              :is-and-search="isAndSearch" />
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </BaseListPage>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import _ from 'lodash'
import * as define from '@/define'
import * as query from '@/queries/stock'
import x from '@/components/mixins/mixin'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/pages/stock/StockBaseListPage'
import ToDownload from '@/components/organisms/ToDownload'

export default {
  name: 'EcStockList',
  components: {
    BaseListPage,
    ToDownload
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      localIsParentLoaded: false,
      showActionList: true
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.EcStock.listIndex,
      tableSetList: (state) => state.EcStock.tableSetList,
      searchKeyword: (state) => state.EcStock.searchKeyword || '',
      isAndSearch: (state) => state.EcStock.isAndSearch || false,
      conditions: (state) => state.EcStock.searchConditions || {},
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'ecStockList'
    },
    storePath () {
      return 'EcStock'
    },
    saveKey () {
      return 'ecStockCondition'
    },
    responsePath () {
      return 'data.ecStockListItems.edges'
    },
    returnPath () {
      return '/ecStock'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_EC_STOCK_LIST
    },
    detailData () {
      return { id: 1 }
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: 'サイト', path: 'node.site.name', sortable: 'custom', width: 200 },
        { type: 'String', label: '商品区分', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => {
            const productType = _.get(row, 'node.sku.productType', '')
            switch (productType) {
              case '0':
              case '1':
                return '通常'
              case '2':
                return '特典'
              case '3':
              case '4':
                return 'デジタル特典'
              default:
                return ''
            }
          }, sortable: true, sortBy: (row) => _.get(row, 'node.sku.productType', ''), width: 150 },
        { type: 'String', label: '商品コード', path: 'node.sku.product.code', sortable: 'custom', width: 250 },
        { type: 'String', label: 'SKUコード', path: 'node.sku.code', sortable: 'custom', width: 250 },
        { type: 'String', label: '商品名(SKU)', elementType: ELEMENT_TYPE.FUNCTION,
          path: (row) => {
            const skuName = _.get(row, 'node.sku.name', '')
            if (skuName !== '') {
              return skuName
            } else {
              return _.get(row, 'node.sku.product.name')
            }
          }, sortable: true, sortBy: (row) => {
            const skuName = _.get(row, 'node.sku.name', '')
            if (skuName !== '') {
              return skuName
            } else {
              return _.get(row, 'node.sku.product.name')
            }
          }, width: 250
        },
        { type: 'String', label: 'アーティスト名', elementType: ELEMENT_TYPE.FUNCTION, path: (row) => {
          const artistName = _.get(row, 'node.sku.artistName', '')
          return artistName !== null && artistName !== undefined ? artistName.replaceAll(',', ', ') : ''
        }, sortable: true, sortBy: (row) => _.get(row, 'node.sku.artistName', ''), width: 250 },
        { type: 'String', label: '無制限在庫', path: (row) => {
          return row.node.ecStock && row.node.ecStock.registered === null ? '無制限' : '数量を見る'
        }, sortable: true, sortBy: (row) => {
          return row.node.ecStock && row.node.ecStock.registered === null ? '無制限' : '数量を見る'
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 150 },
        { type: 'String', label: '在庫種別', path: 'node.stockType', sortable: 'custom',
          codeName: 'd_ec_stock.stock_type', width: 150 },
        { type: 'String', label: '倉庫在庫数', path: (row) => {
          return row.node.site.type === 7 || row.node.ecStockDistr == null
            ? ''
            : row.node.ecStockDistr.amount == null
              ? ''
              : Number(row.node.ecStockDistr.amount)
        }, sortable: 'custom', elementType: ELEMENT_TYPE.FUNCTION, width: 130, class: 'right' },
        { type: 'String', label: '標準在庫数', path: (row) => {
          return row.node.site.type === 7 || row.node.ecStock == null
            ? ''
            : row.node.ecStock.standard == null
              ? ''
              : Number(row.node.ecStock.standard)
        }, sortable: 'custom', elementType: ELEMENT_TYPE.FUNCTION, width: 130, class: 'right' },
        { type: 'Slot', label: '公開数', path: 'registered', class: 'change-log', width: 130 },
        { type: 'String', label: '引当数', path: (row) => {
          return row.node.site.type === 7
            ? ''
            : row.node.ecStock == null
              ? 0
              : Number(row.node.ecStock.allocated)
        }, sortable: 'custom', elementType: ELEMENT_TYPE.FUNCTION, width: 130, class: 'right' },
        { type: 'String', label: '注文数', path: (row) => {
          return row.node.site.type === 7
            ? ''
            : row.node.ecStock == null
              ? 0
              : Number(row.node.ecStock.ordered)
        }, sortable: 'custom', elementType: ELEMENT_TYPE.FUNCTION, width: 130, class: 'right' },
        { type: 'String', label: '指図数', path: (row) => {
          return row.node.site.type === 7
            ? ''
            : row.node.ecStock == null
              ? 0
              : Number(row.node.ecStock.exported)
        }, sortable: 'custom', elementType: ELEMENT_TYPE.FUNCTION, width: 130, class: 'right' },
        { type: 'String', label: '販売可能数', path: (row) => {
          return row.node.site.type === 7
            ? ''
            : row.node.ecStock == null
              ? 0
              : row.node.ecStock.qty == null
                ? ''
                : Number(row.node.ecStock.qty)
        }, sortable: 'custom', elementType: ELEMENT_TYPE.FUNCTION, width: 130, class: 'right' },
        { type: 'String', label: '倉庫在庫数差異', path: (row) => {
          return row.node.site.type === 7 || row.node.ecStockDistr == null || row.node.ecStock == null
            ? ''
            : row.node.ecStockDistr.amount == null
              ? ''
              : row.node.ecStock.registered == null
                ? ''
                : Number(row.node.ecStockDistr.amount) - (Number(row.node.ecStock.qty) < 0 || row.node.ecStock.qty === null ? Number(row.node.ecStock.allocated) + Number(row.node.ecStock.ordered) + Number(row.node.ecStock.exported) : Number(row.node.ecStock.qty) + Number(row.node.ecStock.allocated) + Number(row.node.ecStock.ordered) + Number(row.node.ecStock.exported))
        }, sortable: true, sortBy: (row) => {
          const pathResult = row.node.site.type === 7 || row.node.ecStockDistr == null || row.node.ecStock == null
            ? 'Infinity'
            : row.node.ecStockDistr.amount == null
              ? 'Infinity'
              : row.node.ecStock.registered == null
                ? 'Infinity'
                : Number(row.node.ecStockDistr.amount) - (Number(row.node.ecStock.qty) < 0 || row.node.ecStock.qty === null ? Number(row.node.ecStock.allocated) + Number(row.node.ecStock.ordered) + Number(row.node.ecStock.exported) : Number(row.node.ecStock.qty) + Number(row.node.ecStock.allocated) + Number(row.node.ecStock.ordered) + Number(row.node.ecStock.exported))
          return isNaN(pathResult) ? Infinity : pathResult
        },
        elementType: ELEMENT_TYPE.FUNCTION, width: 175, class: 'right' }
      ]
    }
  },
  created () {
    // 選択肢（在庫種別）のリストを取得する
    const stockTypesOpts = []
    const stockTypes = this.getServiceSiteConfig(null, 'd_ec_stock', 'stock_type') || []
    Object.keys(stockTypes).forEach((key) => {
      stockTypesOpts.push(
        {
          code: Number(key),
          name: _.get(stockTypes[key], 'label', null)
        })
    })
    // 選択肢（在庫有無）のリストを取得する
    const withEmptyOpts = []
    const withEmpty = this.getServiceSiteConfig(null, 'd_ec_stock', 'with_empty') || []
    Object.keys(withEmpty).forEach((key) => {
      withEmptyOpts.push(
        {
          code: Number(key),
          name: _.get(withEmpty[key], 'label', null)
        })
    })
    // 選択肢（無制限在庫）のリストを取得する
    const perpetualOpts = []
    const perpetual = this.getServiceSiteConfig(null, 'd_ec_stock', 'perpetual') || []
    Object.keys(perpetual).forEach((key) => {
      perpetualOpts.push(
        {
          code: Number(key),
          name: _.get(perpetual[key], 'label', null)
        })
    })
    // 選択肢（商品区分）のリストを取得する
    const productCategoriespts = []
    const productCategories = this.getServiceSiteConfig(null, 'd_ec_stock', 'product_categories') || []
    Object.keys(productCategories).forEach((key) => {
      productCategoriespts.push(
        {
          code: Number(key),
          name: _.get(productCategories[key], 'label', null)
        })
    })
    // 選択肢（サイト）のリストを取得する
    const siteOpts = []
    this.sites.forEach(item => {
      if (item.type === 2 || item.type === 3 || item.type === 7) {
        siteOpts.push(
          {
            code: item.code,
            name: item.name
          })
      }
    })

    // ダウンロードが可能のとき、アクションを表示
    const tempThisComponent = this
    setTimeout(() => {
      tempThisComponent.showActionList = this.$isFunctionShown(_.get(tempThisComponent.$refs, 'download.toDownload.funcId', ''))
    }, 1)

    this.$store.dispatch({
      type: 'set',
      states: {
        'EcStock/tableSetList': this._tableSetList,
        'EcStock/searchConditions/stockTypes/options': stockTypesOpts,
        'EcStock/searchConditions/withEmpty/options': withEmptyOpts,
        'EcStock/searchConditions/perpetual/options': perpetualOpts,
        'EcStock/searchConditions/productCategories/options': productCategoriespts,
        'EcStock/searchConditions/siteCodes/options': siteOpts
      }
    })
  },
  methods: {
  }
}
</script>
